import React, { useState } from 'react';
import { Menu, X, LogOut } from 'lucide-react';
import './WorkspaceSidebar.css';

/**
 * Shared left-hand workspace navigation used by the admin, coach and parent
 * dashboards so every role gets the same sidebar-first layout instead of
 * horizontal tab bars.
 */
const WorkspaceSidebar = ({ brandTitle, brandSubtitle, items, activeKey, onSelect, userName, userRole, onLogout, showBrand = true, userAvatarUrl }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleSelect = (key, disabled) => {
    if (disabled) return;
    onSelect(key);
    setMobileOpen(false);
  };

  return (
    <>
      <button
        type="button"
        className="ws-mobile-toggle"
        aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
        onClick={() => setMobileOpen((open) => !open)}
      >
        {mobileOpen ? <X size={20} /> : <Menu size={20} />}
      </button>

      {mobileOpen && <div className="ws-overlay" onClick={() => setMobileOpen(false)} />}

      <aside className={`ws-sidebar ${mobileOpen ? 'open' : ''}`}>
        {showBrand && (
          <div className="ws-brand">
            <div className="ws-brand-mark">🏏</div>
            <div className="ws-brand-copy">
              <strong>{brandTitle}</strong>
              <span>{brandSubtitle}</span>
            </div>
          </div>
        )}

        <nav className="ws-nav">
          <span className="ws-nav-label">Workspace</span>
          {items.map(({ key, label, icon: Icon, disabled, badge }) => (
            <button
              key={key}
              type="button"
              className={`ws-nav-item ${activeKey === key ? 'active' : ''}`}
              onClick={() => handleSelect(key, disabled)}
              disabled={disabled}
              title={disabled ? `${label} (Coming soon)` : label}
            >
              {Icon && <Icon className="ws-nav-icon" size={18} />}
              <span>{label}</span>
              {badge && <span className="ws-nav-badge">{badge}</span>}
            </button>
          ))}
        </nav>

        <div className="ws-footer">
          {userAvatarUrl ? (
            <img src={userAvatarUrl} alt={userName || 'Profile'} className="ws-avatar ws-avatar-img" />
          ) : (
            <div className="ws-avatar">{(userName || '?').charAt(0).toUpperCase()}</div>
          )}
          <div className="ws-footer-copy">
            <strong>{userName}</strong>
            <span>{userRole}</span>
          </div>
          <button type="button" className="ws-logout" aria-label="Logout" onClick={onLogout}>
            <LogOut size={17} />
          </button>
        </div>
      </aside>
    </>
  );
};

export default WorkspaceSidebar;
